export enum TransactionErrorCode {
  /* Generic */
  CertificateError = 'CERTIFICATE_ERROR',
  ProviderError = 'PROVIDER_ERROR',
  Unknown = 'UNKNOWN',

  /* Start Errors */
  InvalidParameters = 'INVALID_PARAMETERS',
  AlreadyInProgress = 'ALREADY_IN_PROGRESS',

  /* Collect Errors */
  StartFailed = 'START_FAILED',
  Cancelled = 'CANCELLED',
  UserCancelled = 'USER_CANCELLED',
  ExpiredTransaction = 'EXPIRED_TRANSACTION',
  ClientError = 'CLIENT_ERROR',
  ValidationFailed = 'VALIDATION_FAILED',
  UnderageUser = 'UNDERAGE_USER',
}
